<template lang='pug' src='./template/Activity.pug'></template>
<style lang='stylus' src='./styles/Activity.styl' scoped></style>

<script>
import DealCard from '../../components/DealCard';
import Loader from '../../components/Loader';
import moment from 'moment';

export default {
    components: {
        DealCard, Loader
    },

    metaInfo: {
        title: 'My Activity',
    },

    filters: {
        postedTime(createdDate) {
            return moment(createdDate).fromNow();
        },
    },

    data() {
        return {
            activeTab: 'liked',
            likedPage: 1,
            postedPage: 1,
            hasMorePosted: true,
            hasMoreLike: true,
            likedDeals: [],
            postedDeals: [],
            actions: [],
            isLoading: false,
            isLoadingPosts: false,
        };
    },



    async mounted() {
        this.isLoading = true;
        this.isLoadingPosts = true;

        const likedDeals = window.axios.get(`/api/user/liked`);
        const postedDeals = window.axios.get(`/api/user/posted`);
        const activities = window.axios.get('/api/user/activity');

        const promises = await Promise.all([likedDeals, postedDeals, activities]);

        this.likedDeals = promises[0].data;
        this.postedDeals = promises[1].data;
        this.actions = promises[2].data.data.reverse();

        this.isLoadingPosts = false;
        this.isLoading = false;
    },

    methods: {
        async loadMoreLikedDeals() {
            this.isLoadingPosts = true;
            this.likedPage = this.likedPage + 1;

            const likedDeals = await window.axios.get('/api/user/liked', {params: {page: this.likedPage}});
            this.likedDeals = this.likedDeals.concat(likedDeals.data);

            if(likedDeals.data.length == 0) {
                this.hasMoreLike = false;
            }

            this.isLoadingPosts = false;
        },

        async loadMorePostedDeals() {
            this.isLoadingPosts = true;
            this.postedPage = this.postedPage + 1;

            const postedDeals = await window.axios.get('/api/user/posted', {params: {page: this.postedPage}});

            this.postedDeals = this.postedDeals.concat(postedDeals.data);

            if(postedDeals.data.length == 0) {
                this.hasMorePosted = false;
            }

            this.isLoadingPosts = false;
        }
    }
};
</script>
